import type { CharacterProfile } from "@/character/storage";
import { profileToGameArt } from "@/character/spritesheet";
import type { GameArtOptions } from "@/game/main";
import { equippedPet, loadPetState } from "@/pet/firestore-storage";
import { petToGameArt } from "@/pet/pet-game-art";
import type { PetDefinition } from "@/pet/types";
import { equippedShadow, loadShadowState } from "@/shadow/firestore-storage";
import { shadowToGameArt } from "@/shadow/shadow-game-art";
import type { ShadowDefinition } from "@/shadow/types";

export function mergeProfileAndShadowGameArt(
  profile: CharacterProfile,
  equipped: ShadowDefinition | null | undefined,
  equippedPetDef?: PetDefinition | null,
): GameArtOptions {
  const player = profileToGameArt(profile);
  const shadow = shadowToGameArt(equipped);
  const pet = petToGameArt(equippedPetDef);
  return { ...player, ...shadow, ...pet };
}

export async function loadGameArtForUser(
  userId: string,
  profile: CharacterProfile,
): Promise<GameArtOptions> {
  const [shadowState, petState] = await Promise.all([
    loadShadowState(userId),
    loadPetState(userId),
  ]);
  return mergeProfileAndShadowGameArt(
    profile,
    equippedShadow(shadowState),
    equippedPet(petState),
  );
}
